export interface IconModel {
    iconsId: number;
    iconName: string;
    url: string;
    active: boolean;
    totalItems:number;
}